import React, { useEffect, useState } from "react";
import "./Filters.scss";
import { useDispatch, useSelector } from "react-redux";
import AssetSize from "./AssetSize";
import SearchCityInput from "./SearchCityInput";
import {
  applyCohortFilterSlice,
  setAssetSize,
  setClearAll,
  setCohortApplied,
  setResetSearchTextForAdditionalInstitutions,
  setSelectedAdditionalInstitutions,
  setSelectedCities,
  setSelectedCohort,
  setSelectedInstitutions,
} from "../../../../rtk-query/features/cohort/cohortSlice";
import { API_STATUS } from "../../../../rtk-query/features/sliceUtil";
import { Button } from "react-bootstrap";

const Filters = () => {
  const dispatch = useDispatch();
  const [disableApplyFilter, setDisableApplyFilter] = useState(true);
  const cohortReducer = useSelector((state) => state?.cohortReducer);
  const [minError, setMinError] = useState("");
  const [maxError, setMaxError] = useState("");

  // useEffect(() => {
  //   const t = cohortReducer?.cohortApplied;
  //   debugger;
  // }, [cohortReducer?.cohortApplied]);

  const selectedCohort = useSelector(
    (state) => state?.cohortReducer?.selectedCohort,
  );
  useEffect(() => {
    if (selectedCohort != null) {
      setDisableApplyFilter(true);
    } else if (
      cohortReducer?.assetSize?.minValue?.length ||
      cohortReducer?.assetSize?.maxValue?.length ||
      cohortReducer?.selectedCities?.length
    ) {
      if (minError === "" && maxError === "") {
        setDisableApplyFilter(false);
      } else {
        setDisableApplyFilter(true);
      }
    } else {
      setDisableApplyFilter(true);
    }
  }, [selectedCohort, cohortReducer, minError, maxError]);

  const onApplyFilter = () => {
    if (cohortReducer?.cohortApplied?.isLoading !== API_STATUS.STATUS_LOADING) {
      dispatch(applyCohortFilterSlice());
    }
  };

  return (
    <>
      <div className="filters">
        <h3>Filters</h3>

        <div className="filter-section">
          <div className="header-section">
            <label>Asset Size</label>
            <span>
              Set a minimum and maximum asset size (in Millions) to shape your
              cohort.
            </span>
          </div>
          <AssetSize
            minError={minError}
            setMinError={setMinError}
            maxError={maxError}
            setMaxError={setMaxError}
          />
        </div>
        <div className="filter-section">
          <div className="header-section">
            <label>State</label>
            <span>Include institutions from selected states.</span>
          </div>
          <SearchCityInput />
        </div>
      </div>
      <div className="filter-footer">
        <button
          className="clear-btn"
          onClick={() => {
            dispatch(setClearAll(true));
            dispatch(setCohortApplied(null));
            dispatch(setSelectedCohort(null));
            dispatch(setSelectedInstitutions([]));
            dispatch(setResetSearchTextForAdditionalInstitutions(false));
            dispatch(setSelectedAdditionalInstitutions([]));
            dispatch(
              setAssetSize({
                minValue: null,
                maxValue: null,
              }),
            );
            dispatch(setSelectedCities([]));
          }}
        >
          Clear all
        </button>
        {/* <button
          className={`apply-btn ${disableApplyFilter ? "disabled" : ""}`}
          disabled={disableApplyFilter}
          onClick={onApplyFilter}
        >
          {cohortReducer?.cohortApplied?.isLoading === API_STATUS.STATUS_LOADING
            ? "Loading..."
            : "Apply Filters"}
        </button> */}
        <Button
          disabled={disableApplyFilter}
          onClick={onApplyFilter}
          className={`apply-btn ${disableApplyFilter ? "disabled" : ""}`}
        >
          Apply Filters
          <i
            className="spinner-grow spinner-grow-sm ms-3"
            role="status"
            style={{
              display:
                cohortReducer?.cohortApplied?.isLoading ===
                API_STATUS.STATUS_LOADING
                  ? "inline-flex"
                  : "none",
            }}
          />
        </Button>
      </div>
    </>
  );
};

export default Filters;
